import { Expose } from "class-transformer";
import { IsNumber } from "class-validator";

export class BSPFinancialProperty {
  @IsNumber()
  @Expose()
  transactionCash!: number;
  @IsNumber()
  @Expose()
  transactionCreditCard!: number;
  @IsNumber()
  @Expose()
  stdCommRate!: number;
  @IsNumber()
  @Expose()
  stdCommonAmount!: number;
  @IsNumber()
  @Expose()
  supCommRate!: number;
  @IsNumber()
  @Expose()
  supCommAmount!: number;
  @IsNumber()
  @Expose()
  taxOnComm!: number;
  @IsNumber()
  @Expose()
  balancePayable!: number;
}
